import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
    isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-banner-dialog',
    templateUrl: './banner-dialog.component.html',
    styleUrls: ['./banner-dialog.component.scss']
})
export class BannerDialogComponent implements OnInit {

    public matcher = new FormErrorStateMatcher();

    public banner: any;

    public objectBanner: any;
    public storedBanner: any;
    public bannerForm: FormGroup;

    public isProduct: boolean = false;
    public typeList: any[] = [];

    constructor (
        public matDialogRef: MatDialogRef<BannerDialogComponent>,
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.isProduct = this.data.isProduct ? true : false;
        this.bannerForm = this.createForm()

        this.typeList.push({'id': 1, 'name': 'Tela 1'})
        this.typeList.push({'id': 2, 'name': 'Tela 2'})

    }

    ngOnInit () {
    }

    createForm () {

      console.log("this.isProduct: " + this.isProduct)

      let form: FormGroup = this.fb.group({
            id: new FormControl(''),
            link: new FormControl('', [Validators.required]),
            type: new FormControl('', [Validators.required]),
            image: new FormControl('' )
        });

        if(!this.isProduct){
          form.removeControl('type')
        }

        return form;

    }

    previewBannerImage (event) {

        if (event.target.files.length === 0)
            return;

        var mimeType = event.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            return;
        }

        var reader = new FileReader();
        this.objectBanner = event.target.files[0];
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
            this.storedBanner = reader.result;
            return event.target.files[0];
        }
    }

}
